<template>
  <v-row class="login__background">
    <TheAlert v-model="alertNotification" />
    <v-col
      cols="12"
      md="8"
      class="d-flex align-center justify-center justify-md-end"
    >
      <v-row class="login__box">
        <v-col cols="12" class="text-center">
          <img src="@/assets/logo_texto_preto.png" alt="Logo LSP" width="45%" />
        </v-col>
        <!--Imagens usadas no email, apenas instânciadas aqui, não deletar-->
        <v-col v-show="false">
          <img src="@/assets/topoAmarelo.png" v-show="false" />
          <img src="@/assets/topoAzul.png" v-show="false" />
          <img src="@/assets/topoVerde.png" v-show="false" />
          <img src="@/assets/rodapeAmarelo.png" v-show="false" />
          <img src="@/assets/rodapeAzul.png" v-show="false" />
          <img src="@/assets/rodapeVerde.png" v-show="false" />
          <img src="@/assets/cliqueEmail.png" v-show="false" />
        </v-col>
        <LoginForm v-if="showLogin" @show-forgot="showLogin = false" />
        <ForgotPasswordForm
          v-else-if="showForgotPassword"
          @go-back="showLogin = true"
        />
        <NewPasswordForm
          v-else
          :token="newPasswordToken"
          @success="showLogin = true"
        />
      </v-row>
    </v-col>
    <LoadingModal />
  </v-row>
</template>
<script>
import LoginForm from "../components/LoginForm";
import ForgotPasswordForm from "../components/ForgotPasswordForm";
import NewPasswordForm from "../components/NewPasswordForm";
import TheAlert from "@/components/TheAlert";
import LoadingModal from "@/components/LoadingModal";
import { mapState } from "vuex";
export default {
  components: {
    LoginForm,
    ForgotPasswordForm,
    NewPasswordForm,
    TheAlert,
    LoadingModal
  },
  computed: {
    ...mapState(["alertNotification"]),
    newPasswordToken() {
      return this.$route.params.token;
    }
  },
  data: () => ({
    showLogin: true,
    showForgotPassword: true,
    showNewPassword: false
  }),
  mounted() {
    if (this.newPasswordToken) {
      this.showLogin = this.showForgotPassword = false;
    }
  }
};
</script>
<style lang="sass" scoped>
.login
  &__background
    @media screen and (max-width: 600px)
    background-image: none
    background-size: cover
    background-color: var(--v-ligthGray-base)
  &__box
    background-color: var(--v-white-base)
    color: white
    padding: 40px 65px 20px
    margin: 70px 50px
    @media screen and (max-width: 600px)
      margin: 0
    max-width: 460px
  &__title
    font-size: 21px
    text-align: center
    &--divider
      border-color: var(--v-secondary-base) !important
  &__logo
    display: block
    margin: 0 auto
</style>